// Module
var code = "<div class=\"widget-content\"> <wt-loading-panel is-loading=\"vm.isLoading\" message=\"vm.loadingMessage\"></wt-loading-panel> <div ng-include=\"'./elementTemplate.html'\" ng-repeat=\"group in vm.groups\"></div> </div>";
// Exports
module.exports = code;